export const urlRegex =
  /(((http(s)?|ftp):\/\/)|www.)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g;

export default urlRegex;
